module.exports = __webpack_public_path__ + "static/media/procore.cbf27e4b.mp4";